import {

	SERVICE_FETCH,
	SERVICE_FETCH_SUCCESS,
	SERVICE_FETCH_FAIL,
} from '../actions';


const INIT_STATE = {
	servicelist:[], 
};

export default (state = INIT_STATE, action) => {

	switch (action.type) {
		case SERVICE_FETCH:
			return { ...state, loading: true, error: ''};
	  case SERVICE_FETCH_SUCCESS:
			return { ...state, loading: false, servicelist: action.payload.servicelist, error: ''};
	  case SERVICE_FETCH_FAIL:
			return { ...state, loading: false, servicelist: 0, error: action.payload.message };
			
		default: return { ...state };
	}
}
